module.exports = __webpack_public_path__ + "img/spine2.2eb1aa37.jpg";